/* istanbul ignore next */
import React, { useState } from 'react';
import AudioAnalyser from 'react-audio-analyser';

const AudioRecorder = props => {
    let [audioType] = useState('audio/wav');
    return (
        <div className="record">
            <AudioAnalyser backgroundColor="#ffffff00"
                size="10%" width={200} strokeColor="#039073" status={props.status}
                audioType={audioType} timeslice={1000}
                className="center"
                stopCallback={e => {
                    const file = window.URL.createObjectURL(e);
                    fetch(file)
                        .then(res => {
                            performBase64ConversionAndAudioFormat(res, props);
                        });
                }}
                errorCallback={err => { }}
            />
        </div>
    );
};

export default AudioRecorder;
function performBase64ConversionAndAudioFormat(res, props) {
    res.blob().then(blob => {
        const reader = new FileReader();
        reader.addEventListener('loadend', async () => {
            const base64FileData = reader.result.split(',');
            props.onAddRecordings(base64FileData);
        });
        reader.readAsDataURL(blob);
    });
}

